import { useLiveQuery } from "dexie-react-hooks";
import { useEffect, useMemo, useState } from "react";

import { db } from "~/db/db";
import useSelect from "~components/Form/hooks/useSelect";
import prepareForOptions from "~services/utils/prepareForOptions";

const useCidades = ({ formikRef, estadoSigla = "", cidadesDisponiveis, salvarLocalStorage, chave }) => {
  const cidadeSelect = useSelect("cidades");
  const [cidade, setCidade] = useState(0);
  const [onCidade, setOnCidade] = useState(false)

  const cidades = useLiveQuery(async () => {
    if (!estadoSigla) return [];

    try {
      const hasSiglaIndex = Boolean(
        db?.cidades?.schema?.idxByName?.["estado.sigla"] ||
        db?.cidades?.schema?.indexes?.some((idx) => idx.name === "estado.sigla")
      );

      if (hasSiglaIndex) {
        const result = await db.cidades.where("estado.sigla").equals(estadoSigla).sortBy("nome");
        if (result.length > 0) return result;
      }

      const estado = await db.estados.where("sigla").equals(estadoSigla).first();
      if (!estado?.id) return [];

      return await db.cidades.where("estadoId").equals(estado.id).sortBy("nome");
    } catch (error) {
      console.error("Erro ao carregar cidades:", error);
      return [];
    }
  }, [estadoSigla]);

  const loading = estadoSigla ? cidades === undefined : false;

  const searchCidadeById = (id) => {
    return db.cidades.get(id);
  }

  const cidadesIbge = useLiveQuery(async () => {
    try {
      if (cidadesDisponiveis?.length) {
        const result = await db.cidades.where("id").anyOf(cidadesDisponiveis).toArray();
        return result.filter((cidade) => cidade.codigoIbge).sort((a, b) => a.nome.localeCompare(b.nome));
      }

      const result = await db.cidades.filter((cidade) => cidade.codigoIbge).toArray();
      return result.sort((a, b) => a.nome.localeCompare(b.nome));
    } catch (error) {
      console.error("Erro ao carregar cidades IBGE:", error);
      return [];
    }
  }, [Array.isArray(cidadesDisponiveis) ? cidadesDisponiveis.join(",") : ""]);

  const optionCidades = useMemo(
    () => prepareForOptions(cidadesIbge || [], ['nome'], 'id'),
    [cidadesIbge]
  );

  function onChangeCidade(e) {
    setOnCidade(e.value > 0)
    cidadeSelect.upDateValue(e.value);
    cidadeSelect.upDateDefaultValue(e || "");

    if (e && e.value && salvarLocalStorage) {
      localStorage.setItem(chave, JSON.stringify(e));
    }
    if (formikRef?.current) {
      formikRef.current.setFieldValue("cidadeId", e.value, false);
      formikRef.current.setFieldTouched("cidadeId", true, false);
    }
    setCidade(e.value);
  }

  function CleanForFilter(option) {
    onChangeCidade(option);
    if (!option || !option.value) {
      localStorage.removeItem(chave);
    }
  }


  useEffect(() => {
    if(salvarLocalStorage){
      const cidade = localStorage.getItem(chave);

    if (cidade) {
      const filialObj = JSON.parse(cidade);
      onChangeCidade(filialObj);
      setCidade(filialObj.value);
    }
    }
  }, [])

  return {
    searchCidadeById,
    loading,
    cidades: cidades || [],
    optionCidades,
    onChangeCidade,
    cidade,
    onCidade,
    cidadeSelect,
    CleanForFilter
  }
}

export default useCidades;